/**
 * v5.5 — Russian translations (default/fallback locale).
 *
 * Любой ключ доступен через useT('group.key') hook. Параметризация —
 * через `{{name}}` placeholder; useT(key, { name: 'Иван' }).
 *
 * Не вешать тут logic / formatting — это plain string map. Числовые формы
 * (1 канал / 2 канала / 5 каналов) — отдельной функцией pluralize в
 * i18n/plural.ts (TODO в полной реализации; пока pluralization в коде).
 */

export const ru = {
  common: {
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    edit: 'Редактировать',
    close: 'Закрыть',
    loading: 'Загрузка...',
    submit: 'Отправить',
    back: 'Назад',
    error: 'Ошибка',
    success: 'Готово',
  },
  auth: {
    login: 'Войти',
    register: 'Регистрация',
    logout: 'Выйти',
    email: 'Email',
    username: 'Username',
    password: 'Пароль',
    forgotPassword: 'Забыли пароль?',
    restoreAccount: 'Восстановить удалённый аккаунт',
    loginCta: 'Войти в SWIPA',
    noAccount: 'Нет аккаунта?',
    createAccount: 'Создать',
  },
  settings: {
    title: 'Настройки',
    sections: {
      profile: 'Профиль',
      sessions: 'Активные сессии',
      privacy: 'Конфиденциальность',
      notifications: 'Уведомления',
      account: 'Аккаунт и данные',
      language: 'Язык',
    },
    privacy: {
      hideLastSeen: 'Скрыть «был онлайн»',
      hideOnline: 'Скрыть онлайн-статус',
      hideReadReceipts: 'Скрыть «прочитано»',
      whoCanCallMe: 'Кто может мне звонить',
      whoCanAddMeToChannels: 'Кто может добавлять меня в каналы',
    },
    account: {
      export: 'Скачать мои данные',
      delete: 'Удалить аккаунт',
      deleteConfirm: 'Удалить аккаунт?',
      deleteHint: 'Восстановление возможно в течение 30 дней через email.',
    },
    language: {
      ru: 'Русский',
      en: 'English',
    },
  },
  channel: {
    joined: '{{name}} присоединился к #{{channel}}',
    left: '{{name}} покинул #{{channel}}',
    kicked: '{{name}} был кикнут из #{{channel}}',
    banned: '{{name}} забанен в #{{channel}}',
    motd: 'MOTD',
    slowMode: 'Медленный режим: подождите {{seconds}} сек',
    transferOwnership: 'Передать владение каналом',
  },
  errors: {
    network: 'Нет связи с сервером',
    unauthorized: 'Не авторизованы',
    forbidden: 'Действие запрещено',
    notFound: 'Не найдено',
    rateLimited: 'Слишком много запросов',
    automodBlocked: 'Сообщение отклонено модерацией',
  },
};

export type TranslationDict = typeof ru;
